import c from "classnames";
import { ComponentProps, forwardRef } from "react";

import classes from "./Clickable.module.css";

type Outline = "none" | "xs" | "sm" | "md" | "lg";

type Props = ComponentProps<"button"> & {
  stretch?: boolean;
  padding?: number;
  /**
   * The size of the outline to apply to the clickable element.
   * xs: 2px
   * sm: 4px
   * md: 6px
   * lg: 8px
   */
  outline?: Outline;
  size?: number;
  center?: boolean;
};

export const Clickable = forwardRef<HTMLButtonElement, Props>(
  (
    { stretch, padding, outline = "none", size, center, ...rest },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        className={c(
          classes.clickable,
          stretch && classes.stretch,
          classes.outline,
          classes[outline],
        )}
        type="button"
        style={{
          padding,
          width: size ? `${size}px` : undefined,
          height: size ? `${size}px` : undefined,
          justifyContent: center ? "center" : undefined,
        }}
        {...rest}
      />
    );
  },
);

Clickable.displayName = "Clickable";
